// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610091035/js/" + chunkId + "." + {"44":"51503bf7","225":"ae3561f3","481":"9b1c3987","486":"fa447946","770":"9bd918c2"}[chunkId] + ".0.8833313187960354.chunk.js";
};